<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="chart"
            ref="highcharts"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import Utils from '@/utils'
import { curvesColorsCharts } from './colorsCharts.js'
import ChartsConfig from '@/mixins/Charts.Config.js'

export default {
    props: {
        data: {
            type: [Array],
            require: true
        },
        loading: {
            type: Boolean,
            require: true
        },
        onHandle: {
            type: [Function],
            require: true
        },
        onPointClick: {
            type: [Function]
        }
    },

    mixins: [ChartsConfig],
    methods: {
        tree_values(data) {
            let tree_categories_values = curvesColorsCharts().treeMap()

            const curves = data[0].filter(item => item.curve !== 'Total')
            const total = curves.reduce((a, b) => a + b.stock_cubage, 0)
            const total_without_new_cubage = curves.reduce(
                (a, b) => a + b.total_without_new_cubage,
                0
            )
            data[0].map(item => {
                if (item.curve !== 'Total') {
                    const valueItem = data[1].isChecked
                        ? item.stock_cubage
                        : item.total_without_new_cubage
                    const totalToBeDivided = data[1].isChecked
                        ? total
                        : total_without_new_cubage
                    tree_categories_values.push({
                        parent: `Curva ${item.curve}`,
                        value: valueItem,
                        percentage_cubage: (
                            (valueItem * 100) /
                            totalToBeDivided
                        ).toFixed(2),
                        y: item.stock_cubage
                    })
                }
            })

            return tree_categories_values
        }
    },

    data() {
        return {
            chartOptions: {
                credits: {
                    text: '',
                    enabled: false
                },
                chart: {
                    type: 'treemap',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    className: 'treemap_chart_resize'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Valores'
                    },
                    labels: {
                        formatter: function() {
                            return Utils.formatNumber(this.value, 'float', true)
                        }
                    }
                },
                tooltip: {
                    formatter: function() {
                        if (this.y)
                            return `<span style="color:${this.color}">\u25CF</span>
                        total de cubagem: <b>${Utils.formatNumber(
                                this.y ?? 0,
                                'float',
                                true
                            )}</b><br />
                        <span style="color:${this.color}">\u25CF</span>
                        percentual sobre o total: <b>${Utils.formatNumber(
                                this.point.percentage_cubage ?? 0,
                                'float',
                                true
                            )}</b>%`
                    }
                },
                plotOptions: {
                    series: {
                        type: 'treemap',
                        layoutAlgorithm: 'stripes',
                        alternateStartingDirection: true,
                        dataLabels: {
                            formatter: function() {
                                let title = this.point.parent,
                                    point = this.point,
                                    value = point.value

                                return `
                                <span>
                                ${title}
                                </span>
                                </b><br />
                                <span class="treemap-money">${Utils.formatNumber(
                                    value,
                                    'float',
                                    true
                                )}</span>
                                </b><br />
                                <span class="treemap-money">
                                    ${this.point.percentage_cubage}%
                                </span>`
                            },
                            align: 'rigth',
                            verticalAlign: 'bottom',
                            style: {
                                fontSize: '12px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fill: 'transparent',
                                stroke: 'transparent'
                            }
                        },
                        events: {
                            click: event => {
                                const curve =
                                    event.point.parent?.split(' ')[1] ??
                                    event.point.id.split(' ')[1]
                                this.onPointClick(curve)
                            }
                        }
                    }
                },
                title: {
                    text: 'Tree Map Cubagem'
                }
            }
        }
    },

    watch: {
        data: {
            handler: function(data) {
                this.$nextTick(() => {
                    const chart = this.$refs.highcharts.chart
                    while (chart.series.length) {
                        chart.series[0].remove()
                    }

                    const series = {
                        levels: [
                            {
                                level: 1
                            }
                        ],
                        data: this.tree_values(data)
                    }

                    chart.addSeries(series)
                })
            },
            deep: true
        }
    }
}
</script>
<style>
.highcharts-figure,
.highcharts-data-table table {
    min-width: 310px;
    max-width: 800px;
    margin: 1em auto;
}

.highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 500px;
}

.highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
}

.highcharts-data-table th {
    font-weight: 600;
    padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
    padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}

.highcharts-data-table tr:hover {
    background: #f1f7ff;
}
</style>
